import {numberFilter} from "./numbers.js";


const BYTES_TO_UNIT_UNITS  = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

/**
 * Konwertuje rozmiar w bajtach na jednostkę
 * @param {Number} bytes Rozmiar w bajtach
 * @param {Number} precision
 * @returns {string}
 */
export const bytesToUnit = (bytes, precision = 1) => {
    bytes = Number(bytes) || 0;
    if (bytes === 0) {
        return '0 B';
    }
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return (bytes / Math.pow(1024, i)).toFixed(precision) + ' ' + BYTES_TO_UNIT_UNITS[i];
};


/**
 * Konwertuje rozmiar na bajty
 * @param {String} input Rozmiar
 * @returns {Number}
 */
export const unitToBytes = (input) => {
    input = String(input);
    const unit = input.substring(input.length - 2).replace(/[^A-z]/g, '');
    let digits = numberFilter(input);
    if (unit === '') {
        return digits;
    }
    let pow = 0;
    let foundUnit = false;
    for (let u of BYTES_TO_UNIT_UNITS) {
        if (unit === u || unit === u.substring(0, 1)) {
            foundUnit = true;
            break
        } else {
            pow++;
        }
    }
    if (!foundUnit) {
        throw `Invalid unit '${unit}'`;
    }
    return digits * Math.pow(1024, pow);
};


/**
 * Zaokrągla liczbę do wielokrotności
 * @param {number} numToRound
 * @param {number} multiple
 * @returns {number}
 */
export const roundUpToMultiple = (numToRound, multiple) => {
    if (multiple === 0) {
        return numToRound;
    }
    const remainder = numToRound % multiple;
    if (remainder === 0) {
        return numToRound;
    }
    return numToRound + multiple - remainder;
}


/**
 * Konwertuje stopnie na radiany
 * @param {number} deg
 * @returns {number}
 */
export const deg2rad = deg => (Math.PI / 180) * deg;
